export const theme = {
  colors: {
    accent: '#28a745',
    accentDark: '#1e8e1e',
    accentDarker: '#1e7e34',
    accentSecondary: '#239923',
    background: '#222222',
    backgroundLight: '#2a2a2a',
    backgroundLighter: '#333333',
    border: '#3f3f3f',
    borderLight: '#c1c1c1',
    text: '#ffffff',
    textDark: '#ccc',
    textDarker: '#aaa',
    textDarkest: '#666',
    error: '#ff6d6d',
    errorDark: '#a31111',
    warning: 'hsl(45, 100%, 90%)',
    warningDark: 'hsl(32, 79%, 40%)',
    info: 'hsl(206, 94%, 92%)',
    infoDark: 'hsl(206, 100%, 30%)',
    success: 'hsl(120, 73%, 92%)',
    successDark: 'hsl(120, 50%, 35%)',
    white: '#fff',
    buttonHover: '#3f3f3f',
    buttonSecondaryHover: '#676767',
  },
  fonts: {
    body: "'Roboto', sans-serif",
    code: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
  },
  fontSizes: {
    xs: '0.4rem',
    sm: '0.8rem',
    base: '1rem',
    lg: '1.2rem',
    xl: '2.5rem',
    iconSmall: '13px',
    iconMedium: '16px',
    iconLarge: '24px',
    bodySmall: '13px',
    bodyMedium: '1rem',
    bodyLarge: '1.2rem',
    h1: '2.5rem',
    h2: '2rem',
    h3: '1.5rem',
  },
  fontWeights: {
    regular: 400,
    semiBold: 600,
    bold: 700,
  },
  buttonSizes: {
    large: {
      padding: '1rem 2rem',
      fontSize: '1rem',
    },
    medium: {
      padding: '0.7rem 1.4rem',
      fontSize: '1rem',
    },
    small: {
      padding: '8px 12px',
      fontSize: '0.8rem',
    },
    icon: {
      padding: '8px 12px',
      fontSize: '0.4rem',
    },
  },
};
